<script setup>
import { swalError } from '@/helper';
import { delete_subscription, get_subscriptions } from '@/services/subscriptions';
import { onMounted, ref } from 'vue';

const isLoading = ref(true)
const subscriptions = ref([])
onMounted(async()=>{
  let response = await get_subscriptions()
  if (response.error){
    Swal.fire({
      title: 'Error',
      html: response.result.error,
      icon: 'error'
    })
    return
  }
  isLoading.value = false
  subscriptions.value = response.result.data.data
  // console.log("🚀 ~ onMounted ~ subscriptions.value:", subscriptions.value)
  
})

async function deletePackage(id){
  let response = await delete_subscription(id)
  if (response.error){
    swalError(response.result)
    return
  }
  let sample = subscriptions.value.findIndex((item)=>item.id == id)
  subscriptions.value.splice(sample, 1)
  Swal.fire({
    title: 'Deleted',
    text: 'Package deleted',
    icon: 'success'
  })
}
</script>

<template>
  <Breadcrumbs main="Subscription Configuration"/>
  
  <div class="container-fluid">
    <div class="row">
      <!-- Page Title -->
      <div class="card">
        <div class="card-body">
          <div class="d-flex align-items-center justify-content-between">
            <h4 class="mb-0">Subscription List</h4>
            <router-link class="btn btn-light-primary"
              :to="{name: 'new-subscription'}"
            >
              Add Packages
            </router-link>
          </div>
        </div>
      </div>
      
      <!-- Item List -->
      <template v-if="isLoading">
        <loadingCard />
      </template>
      <template v-else>
        <template v-if="subscriptions.length == 0">
          <div class="card">
            <div class="card-body">
              <emptyCard
                :link="{
                  routerObj:{
                    name: 'new-subscription'
                  },
                  desc: 'Create a package',
                  class: 'w-50',
                  type: 'link'
                }"
              />
            </div>
          </div>
        </template>
        <template v-else>
          <div v-for="subscription in subscriptions" class="card mb-2" v-auto-animate>
            <div class="card-body py-3 d-flex align-items-center justify-content-between">
              <div>
                <h6 class="mb-0">{{ subscription.attributes.title }}</h6>
                <p>RM {{ subscription.attributes.price }}</p>
              </div>
              <div class="d-flex">
                <router-link class="btn icon-btn btn-light-warning mx-1"
                  :to="{name: 'edit-subscription', params: {id: subscription.id}}"
                >
                  <vue-feather type="edit-2" size="1rem"/>
                </router-link>
                <button class="btn icon-btn btn-light-danger mx-1" 
                  @click="deletePackage(subscription.id)"
                >
                  <vue-feather type="trash" size="1rem"/>
                </button>
              </div>
            </div>
          </div>
        </template>
      </template>
    </div>
  </div>
</template>